import { useContext, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import AppContext from "../context/AppContext";

// COMPONENTS

import { Link, useHistory } from "react-router-dom";

// CSS
import "../constants/global.css";
import "./styles/warranty.css";

import {
  getAllDistributorAddress,
  getAllDistributorCity,
  getAllDistributorPostalCodeAndGroupCode,
  getAllExchangesById,
} from "../api/facom_services";
import {
  getAllDistributorName,
  getAllDistributorPostalCode,
  getDistributorsById,
  updateExchanges,
  updateExchangesStatus,
  getAllDistributors,
} from "../api/facom_services";
import LoadingPag from "../components/atoms/LoadingPag";
import LoadingFacom from "../components/atoms/LoadingFacom";
import FloatAlert from "../components/atoms/FloatAlert";
import { DistributorSection } from "../components";
import { removeTags } from "../helpers/removeHtml";
import useGlobalContent from "../hooks/useGlobalContent";
import { getInLocalStorage, setInLocalStorage } from "../helpers/local-storage-manager";
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

function SelectDistributor(props) {
  let history = useHistory();
  const { width } = useWindowSize();
  const { distributorID, exchengeCreated, setExchengeCreated } = useContext(AppContext);
  const { content } = useContext(AppContext);

  const [alertWrongStatus, setAlertWrongStatus] = useState([false, false, false, false, false]);

  const { replaceGlobalContents } = useGlobalContent();

  const originPath = getInLocalStorage("origin");

  useEffect(() => {
    (async () => {
      if (props.origin) {
        setInLocalStorage("origin", props.origin);
      } else {
        setInLocalStorage("origin", "");
      }
      await getExchangesID();
    })();
  }, []);

  const [selectedPostalCodeFinal, setSelectedPostalCodeFinal] = useState("");
  const [inputDistributor, setInputDistributor] = useState("");

  // const [productReferenceID,setProductReferenceID ] = useState('')
  if (selectedPostalCodeFinal === "") {
    if (content["FORM-NEW-WARRANTY-FINAL.STEP-PLACEHOLDER"]) {
      setSelectedPostalCodeFinal(removeTags(`${content["FORM-NEW-WARRANTY-FINAL.STEP-PLACEHOLDER"]}`));
    }
  }
  var [pageStatus, setPageStatus] = useState(1);

  //API STATE

  const [distributorssrray, setDistributorsArray] = useState([]);
  const [distributorsIdArray, setDistributorsIdArray] = useState([]);
  const [productsID, setProductID] = useState([]);
  const [customerID, setCustomerID] = useState([]);
  const [reasonForExchangesID, setReasonForExchangesID] = useState([]);
  const [exchangesArray, setExchangesArray] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingLast, setLoadingLast] = useState(false);
  const [loadingEx, setLoadingEx] = useState(false);

  const getExchangesID = async () => {
    setLoadingEx(!loadingEx);
    try {
      const response = getAllExchangesById(props.id);
      const data = (await response).data;
      setExchangesArray(data);
      setProductID(data.result.product_id);
      setCustomerID(data.result.customer_id);
      setReasonForExchangesID(data.result.exchange_reason_id);
    } catch (error) {
      console.log("error get exchange");
      console.log(error);
      alertWrongGet(true, false, false, false, false);
    } finally {
      console.log("end");
      setLoadingEx(false);
    }
  };

  //!-------------------DISTRIBUTOR------------------------

  const getDistributor = async (value) => {
    setLoading(!loading);
    try {
      const handlePostalAndGroupCode = value.split(":");
      let arrayByPostalCodeAndGroupCode = [];
      let completeArray = [];
      if (handlePostalAndGroupCode.length > 1) {
        const responseGroupAndPostal = getAllDistributorPostalCodeAndGroupCode(
          handlePostalAndGroupCode[1],
          handlePostalAndGroupCode[0],
          originPath
        );
        const dataGroupAndPostal = (await responseGroupAndPostal).data;

        arrayByPostalCodeAndGroupCode = dataGroupAndPostal.result.items.map(function (items) {
          // return(items.reference)
          var rObj = {
            name: `${items.address?.postal_code} - ${items.name}`,
            id: items.id,
          };
          return rObj;
        });
      } else {
        const responseByName = getAllDistributorName(value, originPath);
        const responseByPostalCode = getAllDistributorPostalCode(value, originPath);
        const responseByAddress = getAllDistributorAddress(value, originPath);
        const responseByCity = getAllDistributorCity(value, originPath);
        const dataByName = (await responseByName).data;
        const dataByPostalCode = (await responseByPostalCode).data;
        const dataByAddress = (await responseByAddress).data;
        const dataByCity = (await responseByCity).data;

        const fullArray = [
          ...dataByName?.result?.items,
          ...dataByPostalCode?.result?.items,
          ...dataByAddress?.result?.items,
          ...dataByCity?.result?.items,
        ];
        completeArray = fullArray.map(function (items) {
          // return(items.reference)
          var rObj = {
            name: `${items.address?.postal_code} - ${items.name}`,
            id: items.id,
          };
          return rObj;
        });
      }
      let arrayOp = [...completeArray, ...arrayByPostalCodeAndGroupCode];
      let hash = {};
      arrayOp = arrayOp.filter((o) => (hash[o.id] ? false : (hash[o.id] = true)));

      setDistributorsArray(arrayOp);

      return arrayOp;
    } catch (error) {
      console.log("error get products");
      console.log(error);
      alertWrongGet(false, true, false, false, false);
    } finally {
      console.log("end");
      setLoading(false);
    }
  };

  const getAllDistributor = async () => {
    setLoading(!loading);
    try {
      const response = getAllDistributors(originPath);

      const data = (await response).data;

      // setProductsArray(data)
      const array1 = data.result.items.map(function (items) {
        // return(items.reference)
        var rObj = {
          name: `${items.address?.postal_code} - ${items.name}`,
          id: items.id,
        };
        return rObj;
      });

      setDistributorsArray(array1);

      return data;
    } catch (error) {
      console.log("error get products");
      console.log(error);
      alertWrongGet();
    } finally {
      console.log("end");
      setLoading(false);
    }
  };

  const [loadinDist, setLoadingDist] = useState(false);
  const getDistributorID = async () => {
    setLoadingDist(!loadinDist);
    try {
      const response = getDistributorsById(distributorID);
      const data = (await response).data;
      setDistributorsIdArray(data);
      return data;
    } catch (error) {
      console.log("error get products");
      console.log(error);
      alertWrongGet(false, false, true, false, false);
    } finally {
      console.log("end");
      setLoadingDist(false);
    }
  };

  const handleChangeDist = (value) => {
    setInputDistributor(value);
    if (value.slice(0, 1) !== "*") {
      if (value.length >= 2) {
        getDistributor(value);
      }
    }
    if (value === "*") {
      getAllDistributor(originPath);
    }
  };

  //* MAPEO DE REASN FOR EXCHANGE EN OBJETO PARA DROPDOWN

  //!------------------------------EXCHANGES------------------------------------

  const updateToSpecificStatus = async (button) => {
    try {
      await updateExchangesInfo();
      const response = updateExchangesStatus(props.id, "Submitted");
      const data = (await response).data;
      setExchengeCreated(true);
      return data;
    } catch (error) {
      console.log("error updated");
      console.log(error);
      alertWrongGet(false, false, false, true, false);
    } finally {
      setLoading(false);
      console.log("end");
      if (button) {
        history.push(`/historic/${originPath}`);
      } else {
        window.location.replace(`/demand/${originPath}`);
      }
    }
  };

  //UPDATE ALL INFO
  const updateExchangesInfo = async () => {
    setLoading(!loading);
    try {
      const response = updateExchanges(props.id, customerID, distributorID, productsID, reasonForExchangesID);
      const data = (await response).data;
      // successUpdated()
      return data;
    } catch (error) {
      console.log("error update info");
      console.log(error);
      alertWrongGet(false, false, false, false, true);
    } finally {
      setLoading(false);
      console.log("end");
    }
  };

  const arrowLeft = "< ";

  //?---------------------------------------------ALERTS----------------------------------------

  const alertWrongGet = (getExchanges, getDistributor, getOneDistributor, updateStatus, updateInfo) => {
    setAlertWrongStatus([getExchanges, getDistributor, getOneDistributor, updateStatus, updateInfo]);
  };

  const renderError = () => {
    return (
      <div>
        {(alertWrongStatus[0] || alertWrongStatus[1] || alertWrongStatus[2] || alertWrongStatus[3] || alertWrongStatus[4]) && (
          <FloatAlert
            message={
              alertWrongStatus[0]
                ? removeTags(`${content["ALERT-ERROR-GET-EXCHANGES"]}`)
                : alertWrongStatus[1]
                ? removeTags(`${content["ALERT-ERROR-GET-DISTRIBUTORS"]}`)
                : alertWrongStatus[2]
                ? removeTags(`${content["ALERT-ERROR-GET-ONE-EXCHANGE"]}`)
                : alertWrongStatus[3]
                ? removeTags(`${content["ALERT-ERROR-UPDATE-STATUS"]}`)
                : alertWrongStatus[4]
                ? removeTags(`${content["ALERT-ERROR-UPDATE-1"]}`)
                : ""
            }
            show={
              alertWrongStatus[0] || alertWrongStatus[1] || alertWrongStatus[2] || alertWrongStatus[3] || alertWrongStatus[4] ? true : false
            }
            setShow={() => {
              setTimeout(function () {
                setAlertWrongStatus(false);
              }, 4000);
            }}
          />
        )}
      </div>
    );
  };

  //? -----------------------------------STEP 5 --------------------------------------

  const renderFinal = () => {
    return (
      <DistributorSection
        distributorsArray={distributorssrray}
        selectedPostalCodeFinal={selectedPostalCodeFinal}
        onSelectDdDist={(value) => {
          setSelectedPostalCodeFinal(value);
          getDistributorID(distributorID);
        }}
        onChangeDdDist={(value) => {
          handleChangeDist(value);
        }}
        loadingDist={loadinDist}
        distributorsIdArray={distributorsIdArray}
        distributorID={distributorID}
        width={width}
        setPageStatusBefore={() => {
          updateToSpecificStatus(true);
          setPageStatus(4);
        }}
        setPageStatusAfter={() => {
          updateToSpecificStatus(false);
          setPageStatus(4);
        }}
      />
    );
  };

  var ColorPage = false;
  if (pageStatus === 1 || pageStatus === 6) {
    ColorPage = true;
  } else {
    ColorPage = false;
  }

  return (
    <div>
      <div
        className="row py-5"
        style={ColorPage === true ? { backgroundColor: "#000", margin: "0" } : { backgroundColor: "#1B1E1F", margin: "0" }}
      >
        <Link to={`/historic/${originPath}`}>
          <h6 className="h6-return" style={{ display: "flex", gap: "10px" }}>
            {arrowLeft}
            <div dangerouslySetInnerHTML={{ __html: content["FORM.ALL.BACK"] }}></div>
          </h6>
        </Link>

        {!loadingEx ? (
          <div>
            <div className="row pb-5">
              <div>
                <h2 className="h1-stl Center pt-5 ">
                  <div
                    dangerouslySetInnerHTML={{ __html: replaceGlobalContents(content["FORM-NEW-WARRANTY-FINAL.STEP-TITLE"]) }}
                    className="main-titles"
                  ></div>
                </h2>
                <div className="py-3">
                  <div
                    dangerouslySetInnerHTML={{ __html: replaceGlobalContents(content["FORM-NEW-WARRANTY-FINAL.STEP-INFO"]) }}
                    className="description-text"
                  ></div>
                </div>
              </div>
            </div>
            {!loadingLast ? <div>{renderFinal()}</div> : <LoadingFacom />}
          </div>
        ) : (
          <div className="py-5">
            <LoadingFacom />
          </div>
        )}
      </div>
      {renderError()}
      <LoadingPag open={loading} />
    </div>
  );
}

export default SelectDistributor;
